import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { GetManagementWebhookEventRequestDto } from '@domain/management-webhook-event/dtos/get-management-webhook-event.request.dto';
import { ManagementWebhookEventResponseDto } from '@domain/management-webhook-event/dtos/management-webhook-event.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementWebhookEventService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management/webhook/event');
  }

  get(request: GetManagementWebhookEventRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<ApiResponse<ManagementWebhookEventResponseDto[]>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
